import { BsThreeDotsVertical } from "react-icons/bs";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { useSettings } from "../../../store/setting_store";

const PopingOutPayments = ({ gateway_id }) => {
  const layout_page = useSettings((state) => state.layout_page);
  return (
    <div>
      <div className="item-action dropdown">
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <div>
              <div variant="contained" {...bindTrigger(popupState)}>
                <BsThreeDotsVertical
                  style={{
                    color: layout_page?.primary_color,
                    cursor: "pointer",
                  }}
                />
              </div>
              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}>
                <Typography sx={{ p: 2 }}>
                  <div className="px-3 d-flex flex-column gap-3">
                    {/* EDIT GATEWAY */}
                    <Link to={"/edit_payment_gateway/" + gateway_id}>
                      <div className="d-flex gap-2" style={{ color: "gray" }}>
                        <FaEdit />
                        <h6>Edit</h6>
                      </div>
                    </Link>
                  </div>
                </Typography>
              </Popover>
            </div>
          )}
        </PopupState>
      </div>
    </div>
  );
};
export default PopingOutPayments;
